export type AdminViewMode = "player" | "admin";
export interface AdminViewIdentity {
  accountId: string;
  bootstrapAccountId: string | null;
  role: "user" | "admin";
  authenticated: boolean;
  sessionAccountId: string | null;
  sessionId: string | null;
}
type ChoiceStorage = Pick<Storage, "getItem" | "setItem">;

/** This is a display preference. Only the server profile grants administrator access. */
export function adminViewScope(identity: AdminViewIdentity): string | null {
  return identity.authenticated &&
    identity.role === "admin" &&
    identity.accountId === identity.bootstrapAccountId &&
    identity.accountId === identity.sessionAccountId &&
    identity.sessionId
    ? `${identity.accountId}:${identity.sessionId}`
    : null;
}

export function readAdminViewChoice(
  storage: ChoiceStorage | null,
  identity: AdminViewIdentity,
): AdminViewMode | null {
  if (!adminViewScope(identity)) return null;
  try {
    const raw: unknown = JSON.parse(
      storage?.getItem(choiceKey(identity.accountId)) ?? "null",
    );
    if (
      !raw ||
      typeof raw !== "object" ||
      !("sessionId" in raw) ||
      !("mode" in raw)
    )
      return null;
    return raw.sessionId === identity.sessionId &&
      (raw.mode === "player" || raw.mode === "admin")
      ? raw.mode
      : null;
  } catch {
    return null;
  }
}

export function writeAdminViewChoice(
  storage: ChoiceStorage | null,
  identity: AdminViewIdentity,
  mode: AdminViewMode,
): void {
  if (!adminViewScope(identity)) return;
  try {
    storage?.setItem(
      choiceKey(identity.accountId),
      JSON.stringify({ sessionId: identity.sessionId, mode }),
    );
  } catch {
    /* The in-memory selection still works when browser storage is unavailable. */
  }
}

function choiceKey(accountId: string): string {
  return `fr:admin-view:${encodeURIComponent(accountId)}`;
}
